<template>
	<div class="card mb-5 shadow-sm">
		<div class="card-body py-0">
			<select
				class="form-control mx-auto my-4 w-auto"
				:disabled="conditions.length < 2"
				v-model="globalOperator"
			>
				<option value="$and">List records matching ALL conditions (AND)</option>
				<option value="$or">List records matching ANY condition (OR)</option>
				<option value="$nor">List records matching NONE of the conditions (NOR)</option>
			</select>
			<FilterCondEditor
				:applied="true"
				v-for="(c, i) in conditions"
				:condition="c"
				:fields="fields"
				:index="i"
				:key="i + JSON.stringify(c)"
				@apply="modCondition"
				@remove="delCondition"
			/>
			<FilterCondEditor
				:fields="fields"
				@apply="addCondition"
			/>
		</div>
	</div>
</template>

<script>
import FilterCondEditor from '@/components/FilterCondEditor'

export default {
	props: ['fields'], // TODO would be nice if we could get a "find" object as input too and parse it
	components: { FilterCondEditor },
	data() {
		return {
			conditions: [],
			globalOperator: '$and',
		}
	},
	watch: {
		globalOperator() {
			this.emitFilter()
		}
	},
	methods: {
		addCondition(condition) {
			this.modCondition(condition)
		},
		modCondition(condition, i) {
			if (i || i === 0) {
				this.$set(this.conditions, i, condition)
			} else {
				this.conditions.push(condition)
			}
			this.emitFilter()
		},
		delCondition(i) {
			this.conditions.splice(i, 1)
			this.emitFilter()
		},
		emitFilter() {
			const { conditions } = this
			const mc = conditions.map((condition) => {
				const { field, operator, argument } = condition
				const rule = {}
				rule[field.field] = {}
				rule[field.field][operator] = argument
				return rule
			})

			const find = {}
			if (mc.length) {
				find[this.globalOperator] = mc
			}
			console.log(find, conditions)
			this.$emit('update', find, conditions.length)
		},
	},
}
</script>
